<ul
  data-testid="navigation-menu"
  [class.collapsed-menu]="isCollapsed()"
  *transloco="let t"
  [nzInlineCollapsed]="isCollapsed()"
  nz-menu
  nzMode="inline"
  nzTheme="light"
>
  @for (navigationItem of navigationItems(); track navigationItem.translationKey) {
    @if (!navigationItem.children?.length) {
      <li nz-menu-item [nzSelected]="navigationItem.active" [routerLink]="navigationItem.route" [nzMatchRouter]="true">
        @if (navigationItem.icon) {
          <aml-icon [iconName]="navigationItem.icon"></aml-icon>
        }
        <span class="menu-text" [class.is-hidden]="isCollapsed()">
          {{ t(navigationItem.translationKey) || navigationItem.name }}
        </span>
      </li>
    } @else {
      <li nz-submenu [nzOpen]="!isCollapsed() && navigationItem.open" [nzTitle]="titleTpl">
        <ng-template #titleTpl>
          @if (navigationItem.icon) {
            <aml-icon [iconName]="navigationItem.icon"></aml-icon>
          }
          <span class="menu-text" [class.is-hidden]="isCollapsed()">{{
            t(navigationItem.translationKey) || navigationItem.name
          }}</span>
        </ng-template>
        <ul>
          @for (childNavigationItem of navigationItem.children; track childNavigationItem.translationKey) {
            <li nz-menu-item [nzMatchRouter]="true" [routerLink]="childNavigationItem.route">
              @if (childNavigationItem.icon) {
                <aml-icon [iconName]="childNavigationItem.icon"></aml-icon>
              }
              <span class="menu-text">{{ t(childNavigationItem.translationKey) || childNavigationItem.name }}</span>
            </li>
          }
        </ul>
      </li>
    }
  }
</ul>
